import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
  ownerCancellationReason: string;
};
export type ChangeCarResponse = {
  data: Reservation;
};

export const useCancelReservation = createMutation<
  ChangeCarResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/reservations/${variables.id}/cancel`,
      method: 'PUT',
      data: {
        owner_cancellation_reason: variables.ownerCancellationReason,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
